import useTheme from '@/hooks/useTheme';

export default function ThemeProvider({ children }) {
  useTheme();
  return children;
}
